import i18nFactory from '@yandex-int/i18n';

import { ValidationResultItem } from '../../../typings/common';
import { createErrorsMapper } from '../../ErrorsMapper/ErrorsMapper';

import * as keyset from './MobileTrackerDesignerErrorHelper.i18n';

const i18n = i18nFactory(keyset);

const MAX_PARAMS_COUNT = 5;

export const mobileTrackerDesignerErrors = createErrorsMapper<{}>(
    ({ idx }) => [
        {
            path: ['trackers', idx],
            codes: [
                {
                    code: 'CollectionDefectIds.Size.SIZE_CANNOT_BE_MORE_THAN_MAX',
                    message: (err: ValidationResultItem): string => {
                        return i18n('size-cannot-be-more-than-max', {
                            total: MAX_PARAMS_COUNT
                        });
                    }
                }
            ]
        },
        {
            path: ['trackers', idx, 'url'],
            codes: [
                {
                    code: 'BannerDefectIds.Gen.TRACKING_URL_DOESNT_CONTAIN_MACROS',
                    message: (err: ValidationResultItem): string => {
                        return i18n('tracking-url-doesnt-contain-macros');
                    }
                },
                {
                    code: 'MobileAppDefects.Gen.TRACKER_URL_DOMAIN_DOES_NOT_MATCH_SELECTED_TRACKER_SYSTEM',
                    message: (err: ValidationResultItem): string => {
                        return i18n('tracker-url-does-not-match-selected-tracker-system');
                    }
                },
                {
                    code: 'StringDefectIds.CANNOT_BE_EMPTY',
                    message: (err: ValidationResultItem): string => {
                        return i18n('cannot-be-empty');
                    }
                },
                {
                    code: 'DefectIds.CANNOT_BE_NULL',
                    message: (err: ValidationResultItem): string => {
                        return i18n('cannot-be-empty');
                    }
                }
            ]
        },
        {
            path: ['trackers', idx, 'trackerId'],
            codes: [
                {
                    code: 'DefectIds.CANNOT_BE_NULL',
                    message: (err: ValidationResultItem): string => {
                        return i18n('cannot-be-empty');
                    }
                },
                {
                    code: 'StringDefectIds.CANNOT_BE_EMPTY',
                    message: (err: ValidationResultItem): string => {
                        return i18n('cannot-be-empty');
                    }
                }
            ]
        },
        {
            path: ['trackers', idx, 'trackingSystem'],
            codes: [
                {
                    code: 'StringDefectIds.CANNOT_BE_EMPTY',
                    message: (err: ValidationResultItem): string => {
                        return i18n('cannot-be-empty');
                    }
                },
                {
                    code: 'DefectIds.CANNOT_BE_NULL',
                    message: (err: ValidationResultItem): string => {
                        return i18n('cannot-be-empty');
                    }
                },
                {
                    code: 'BannerDefectIds.Gen.THIS_TRACKING_SYSTEM_DOMAIN_ONLY_SUPPORTS_HTTP',
                    message: (err: ValidationResultItem): string => {
                        return i18n('this-tracking-system-domain-only-supports-https');
                    }
                },
                {
                    code: 'BannerDefectIds.Gen.THIS_TRACKING_SYSTEM_DOMAIN_NOT_SUPPORTED',
                    message: (err: ValidationResultItem): string => {
                        return i18n('this-tracking-system-domain-not-supported');
                    }
                }
            ]
        }
    ],
    error => i18n('default-error', { errorCode: error.code })
);
